import { FunctionComponent } from 'react';
import { useParams } from 'react-router';
import { Button, Section } from '../../components';
import requirementCompleteImage from '../../assets/requirement_complete.png';

export const StateIntakeSuccess: FunctionComponent = () => {
  const { locationId } = useParams<Record<string, string>>();

  return (
    <Section>
      <div className="mt-32 flex flex-col items-center justify-center">
        <img
          src={requirementCompleteImage}
          alt="Requirement complete"
          className="mb-12 ml-10 h-44 w-56"
        />
        <div className="mb-10 text-5xl font-extrabold leading-10 text-gray-700">
          We&apos;re on it!
        </div>
        <div className="mb-8 w-5/12 text-center text-sm">
          We received your information and will begin setting up the location.
        </div>
        <Button as="a" href={`/locations/usa/${locationId}`} size="large">
          Track progress
        </Button>
      </div>
    </Section>
  );
};

export default StateIntakeSuccess;
